<template>
  <v-layout fill-height row wrap>
    <v-flex pa-4 v-for="item in items" xs4>
      <v-card style="height: 100%">
        <v-card-title style="font-weight: 600; padding-bottom: 0px">{{
          item.name
        }}</v-card-title>
        <v-flex ma-3 pb-3>
          <p style="margin-bottom: 6px" v-for="subitem in item.subitems">
            <span>
              •
              <router-link :to="subitem.path">{{ subitem.name }}</router-link>
            </span>
          </p>
        </v-flex>
      </v-card>
    </v-flex>
  </v-layout>
</template>


<script>
export default {
  name: "Overview",
  props: {
    msg: String,
  },
  data: function () {
    return {
      items: [
        {
          name: "General",
          subitems: [
            {
              name: "Availability Regions",
              path: "/settings/general/availability/regions",
            },
            {
              name: "Driver Groups",
              path: "/settings/driver_group",
            },
            {
              name: "Center of Availability",
              path: "/settings/general/availability/center",
            },
            {
              name: "Zones",
              path: "/settings/general/zones",
            },
          ],
          path: "/settings/general",
        },
        {
          name: "Bookings",
          subitems: [
            {
              name: "Driver App",
              path: "/settings/booking/flagged_bookings",
            },
            {
              name: "Predefined Booking Messages",
              path: "/settings/booking/predefined_messages",
            },
            {
              name: "Web Bookings",
              path: "/settings/booking/web",
            },
            {
              name: "Cancellation Fees",
              path: "/settings/booking/cancellations",
            },
          ],
        },
        {
          name: "Finance",
          subitems: [
            {
              name: "Manage driver invoicing settings",
              path: "/settings/invoicing",
            },
          ],
        },
        {
          name: "Messages and Emails",
          subitems: [
            {
              name: "Alter/Update SMS and Push Notifications",
              path: "/settings/messages_emails/notifications",
            },
          ],
        },
        {
          name: "Pricing",
          subitems: [
            // "Ride Types & Tariffs",
            {
              name: "Ride Types & Tariffs",
              path: "/settings/pricing/ride_types",
            },
            { name: "Fixed Price Trips", path: "/settings/pricing/fixed_cost" },
             { name: "Parking and Tolls", path: "/settings/pricing/parking_and_tolls" },
              { name: "Booking Property Additionals", path: "/settings/pricing/property_additional_charges" },
              { name: "Meter", path: "/settings/pricing/meter" },
          ],
        },
        {
          name: "API & Third Party",
          subitems: [
            { name: "SumUP Card Payment", path: "/settings/third_party/sumup" },
            {
              name: "Messagebird Number Masking",
              path: "/settings/third_party/messagebird_number_masking",
            },
            {
              name: "Aryvo API Config",
              path: "/settings/third_party/aryvo",
            },
          ],
        },
        {
          name: "Promotions and Loyalty",
          subitems: [
            { name: "View/Edit Promotions", path: "/settings/promotions/" },
            { name: "Loyalty Tiers", path: "/settings/loyalty_tiers/" },
            { name: "Loyalty Rewards", path: "/settings/loyalty_rewards/" },
          ],
        },
        {
          name: "Apps",
          subitems: [{ name: "App Versions", path: "/settings/apps/versions" }],
        },
        {
          name: "Auto-Dispatch",
          subitems: [
            { name: "Dispatch Parameters", path: "/settings/dispatch" },
          ],
        },
        {
          name: "Office Users",
          // subitems: ["Add/Remove Office Users", "Update User Permissions"]
        },
        {
          name: "My Account",
          subitems: [
            // "Update contact details",
            // "Change your password",
            // "Change profile picture"
          ],
        },
        {
          name: "System Admin Only",
          subitems: [
            {
              name: "System Configuration",
              path: "/settings/system_configuration",
            },
            // "Update contact details",
            // "Change your password",
            // "Change profile picture"
          ],
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
